import { Slider } from '@/core/ui/atoms/slider'
import { PlaceReviewsModel } from '@/features/content/types/models/place.model'
import { use } from 'react'
import { Divider } from '../../../../../core/ui/components/divider'
import { TestimonialCard } from './testimonial-card'
type Props = {
  className?: string
  reviewsPromise: Promise<PlaceReviewsModel>
}

export const Testimonial: React.FC<Props> = ({
  className = '',
  reviewsPromise,
}) => {
  const reviews = use(reviewsPromise)

  if (!reviews || !reviews.length) {
    return null
  }
  return (
    <section className={`relative z-10 ${className}`}>
      <h2 className='text-4xl font-semibold'>Testimonial</h2>

      <Divider className='mt-3' />
      <Slider
        showDots
        slides={reviews.map(review => (
          <TestimonialCard
            date={review.relative_time_description}
            name={review.author_name}
            rate={review.rating || 0}
            review={review.text}
            key={review.author_name}
          />
        ))}
        className='my-4 h-full cursor-grab'
        slidesPerView={1}
        breakpoints={{ [1024]: 3, [768]: 2, [640]: 1 }}
      />
    </section>
  )
}
